import React from 'react';
import type { OptionType } from '@withjoy/joykit';
import { Box, SelectV1 } from '@withjoy/joykit';
interface CurrencySelectorProps {
  handleOnCurrencyChange: (value: OptionType) => void;
  currencyOptions: Array<OptionType>;
  selectedCurrency?: OptionType;
  numTopRanked?: number;
}

export const CurrencySelector: React.FC<CurrencySelectorProps> = props => {
  const { currencyOptions, handleOnCurrencyChange, selectedCurrency, numTopRanked } = props;

  const handleOnChange = (value: OptionType | null) => {
    if (value) {
      handleOnCurrencyChange(value);
    }
  };

  return (
    <Box>
      <SelectV1
        divideAt={numTopRanked}
        value={selectedCurrency}
        searchable={false}
        onChange={handleOnChange}
        options={currencyOptions}
      />
    </Box>
  );
};
